import { Row } from 'antd'
import KForm from 'app/components/Modules/Form/KForm'
import KInputText from 'app/components/Modules/Form/KInputText'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import React from 'react'

import { MemberProps } from '../convention'

type Props = {
  onSuccess?: (contact: IContact) => void
  onCancel?: () => void
  portalId?: string
  loading?: boolean
}

const Form: React.FC<MemberProps<Partial<IContact>, Props>> = ({ member, props }) => {
  return (
    <KForm
      silentSuccess
      layout="vertical"
      cancelable={Boolean(member?.id)}
      recordType={RecordType.contact}
      visualRecordType={RecordType.delivery_contact}
      recordId={member?.id}
      {...props}>
      <Row gutter={[16, 0]}>
        <KCol span={12}>
          <KInputText name="first_name" required />
        </KCol>
        <KCol span={12}>
          <KInputText name="last_name" required />
        </KCol>
        <KCol span={24}>
          <KInputText name="tel" required />
        </KCol>
      </Row>
    </KForm>
  )
}

export default Form
